<template>
  <label :class="[value !== false ? 'chosen-family' : '']">
    <v-layout align-start>
      <v-radio
        v-if="value !== false"
        :value="value"
        :ripple="false"
      />
      <div>
        <slot name="createdBy" />
        <slot name="indicator" />
        <div class="family-item__body">
          <p class="mb-0 word-break">
            <EntranceFamilyElement
              v-if="family.name.length > 0"
              class="mr-1"
              :marked="marked"
              :item="family.name"
            />
            <EntranceFamilyElement
              :item="family.surname"
              :marked="marked"
            />
          </p>

          <p class="mb-0">
            <EntranceFamilyElement
              :item="family.street"
              :marked="marked"
            />
            <EntranceFamilyElement
              :item="family.building"
              :marked="marked"
            />
            <EntranceFamilyElement
              v-if="family.flat.length > 0"
              :item="family.flat"
              :marked="marked"
            />
          </p>

          <p class="mb-0">
            <EntranceFamilyElement
              :item="family.postalCode"
              :marked="marked"
            />
            <EntranceFamilyElement
              :item="family.city"
              :marked="marked"
            />
          </p>

          <p
            v-for="(item, index) in family.phones"
            :key="index"
            class="mb-0"
          >
            <EntranceFamilyElement
              :item="item"
              :marked="marked"
            />
          </p>
        </div>
      </div>
    </v-layout>
  </label>
</template>

<script>
import EntranceFamilyElement from '@/components/widgets/addFamily/familySimilar/EntranceFamilyElement';

export default {
    name: 'EntranceFamilyItem',
    components: { EntranceFamilyElement },
    props: {
        family: {
            required: true,
            type: Object
        },
        marked: {
            default: true,
            type: Boolean
        },
        value: {
            default: false
        }
    }
};
</script>

<style scoped>
.word-break {
  word-break: break-all;
}
</style>
